<div class="main-content">
  <div class="customer-support">
    <div class="banner">
      <picture>
        <source media="(max-width:768px)" srcset="{{environment?.blobUrl}}/assets/images/customer-support/customer-support-mob-banner.webp">
        <img loading="lazy" src="{{environment?.blobUrl}}/assets/images/customer-support/customer-support-banner.webp" alt="Customer Support | Luminous">
      </picture>
    </div>
    <div class="container">
      <div class="support-information">
        <div class="row align-items-md-center">
          <div class="col-md-6">
            <h1 class="p-0 m-0">Customer Support</h1>
          </div>
          <div class="col-md-6">
            <p>Luminous Care<br>
              We take pride in providing the best pre and after-sales support to all our customers. Go ahead, connect
              with us – we would love to hear from you!</p>
          </div>
        </div>
      </div>
      <div class="category-main">
        <div class="row">
          <div class="col-md-6 col-lg-4">
            <a class="hyperlink" [routerLink]="['/warranty-registration']">
              <div class="category arrow">
                <span><img loading="lazy" src="{{environment?.blobUrl}}/assets/images/customer-support/Register-a-product.svg"
                    alt="Register a product | Luminous"></span>
                <h4>Register a product</h4>
              </div>
            </a>
          </div>
          <div class="col-md-6 col-lg-4">
            <a class="hyperlink" [routerLink]="['/book-complaint']">
              <div class="category arrow">
                <span><img loading="lazy" src="{{environment?.blobUrl}}/assets/images/customer-support/book-complaint.svg" alt="Book a complain | Luminous"></span>
                <h4>Book a complaint</h4>
              </div>
            </a>
          </div>
          <div class="col-md-6 col-lg-4">
            <a class="hyperlink" [routerLink]="['/store-locator']">
              <div class="category arrow">
                <span><img loading="lazy" src="{{environment?.blobUrl}}/assets/images/customer-support/store-locator.svg" alt="Store locator | Luminous"></span>
                <h4>Store locator</h4>
              </div>
            </a>
          </div>
          <div class="col-md-6 col-lg-4">
            <a class="hyperlink" [routerLink]="['/service-center-locator']">
              <div class="category arrow">
                <span><img loading="lazy" src="{{environment?.blobUrl}}/assets/images/customer-support/Service-centre-locator.svg"
                    alt="Service centre locator | Luminous"></span>
                <h4>Service centre locator</h4>
              </div>
            </a>
          </div>
          <div class="col-md-6 col-lg-4">
            <a class="hyperlink" [routerLink]="['/service-care-pack']">
              <div class="category arrow">
                <span><img loading="lazy" src="{{environment?.blobUrl}}/assets/images/customer-support/service-care-pack.svg" alt="Service care pack | Luminous"></span>
                <h4>Service care pack</h4>
              </div>
            </a>
          </div>
          <div class="col-md-6 col-lg-4">
            <a class="hyperlink" [routerLink]="['/contact-us']">
              <div class="category arrow">
                <span><img loading="lazy" src="{{environment?.blobUrl}}/assets/images/customer-support/contact-us.svg" alt="Contact us | Luminous"></span>
                <h4>Contact us</h4>
              </div>
            </a>
          </div>
        </div>
      </div>
      <div class="category-main pt-0 highlights">
        <h2 class="mb-5">Luminous Care Highlights</h2>
        <div class="row">
          <div class="col-md-6 col-lg-4">
            <h4 class="d-flex align-items-center"> <img loading="lazy" class="luminousCareHighlightsImage"
                src="{{environment?.blobUrl}}/assets/images/customer-support/onSiteServiceFacility.svg" alt="On-SiteServiceFacility | Luminous">
              On-site service facility</h4>
          </div>
          <div class="col-md-6 col-lg-4">
            <h4 class="d-flex align-items-center"><img loading="lazy" class="luminousCareHighlightsImage"
                src="{{environment?.blobUrl}}/assets/images/customer-support/mobileAppForCallLogin.svg" alt="MobileAppForCallLogin | Luminous">
              Mobile app for call login</h4>
          </div>
          <div class="col-md-6 col-lg-4">
            <h4 class="d-flex align-items-center"><img loading="lazy" class="luminousCareHighlightsImage"
                src="{{environment?.blobUrl}}/assets/images/customer-support/wideNetworkOfServiceCentres.svg"
                alt="WideNetworkOfServiceCentres"> Wide network of service centres
            </h4>
          </div>
          <div class="col-md-6 col-lg-4">
            <h4 class="d-flex align-items-center"><img loading="lazy" class="luminousCareHighlightsImage"
                src="{{environment?.blobUrl}}/assets/images/customer-support/directService.svg" alt="DirectService | Luminous">Direct service</h4>
          </div>

          <div class="col-md-6 col-lg-4">
            <h4 class="d-flex align-items-center"><img loading="lazy" class="luminousCareHighlightsImage"
                src="{{environment?.blobUrl}}/assets/images/customer-support/1400_FieldServicePersonnel.svg"
                alt="1400_FieldServicePersonnel">1400+ field service personnel</h4>
          </div>
          <div class="col-md-6 col-lg-4">
            <h4 class="d-flex align-items-center"><img loading="lazy" class="luminousCareHighlightsImage"
                src="{{environment?.blobUrl}}/assets/images/customer-support/24_7CallLogin.svg" alt="24_7CallLogin | Luminous">24/7 call login
              facility at centralized call centre</h4>
          </div>
        </div>
      </div>
    </div>
    <app-help-support></app-help-support>

  </div>
</div>
